import { mutatorAction } from 'satcheljs';
import getFeedbackRibbonState from '../selectors/getFeedbackRibbonState';

export let setFeedbackRibbonResponse = mutatorAction(
    'setFeedbackRibbonResponse',
    (feedbackRibbonResponse: string, sessionId: string) => {
        getFeedbackRibbonState(sessionId).feedbackRibbonResponse = feedbackRibbonResponse;
    }
);
